import { Grid, Typography, useTheme } from "@material-ui/core";
import GoBackIconButton from "./icon-buttons/GoBackIconButton";

interface props {
  title: string;
  backButton?: boolean;
  onBackCallback?: () => void;
}

const ScreenTitle = ({ title, backButton, onBackCallback }: props) => {
  const theme = useTheme();
  return (
    <Grid item xs={12} md={12} lg={12}>
      {backButton && (
        <>
          <GoBackIconButton size="medium" onClick={onBackCallback} />
          &nbsp;
        </>
      )}
      <Typography
        variant="subtitle1"
        style={{
          fontSize: "19pt",
          fontWeight: 700,
          color: theme.palette.primary.dark,
        }}
      >
        {title}
      </Typography>
    </Grid>
  );
};

export default ScreenTitle;
